const en = {
  time_zone: 'Time Zone',
  chart: 'Chart',

  //Timeframes every
  every: 'Every',
  granularity: 'Granularity',
  second: 'second',
  seconds: 'seconds',
  seconds_short: 's',
  minute: 'minute',
  minutes: 'minutes',
  minute_short: 'm',
  hour: 'hour',
  hours: 'hours',
  hour_short: 'h',
  day: 'day',
  days: 'days',
  no_auto_refresh_short: 'None',

  //chrono units
  nanos: 'Nanos',
  micros: 'Micros',
  millis: 'Millis',
  half_days: 'Half days',
  weeks: 'Weeks',
  months: 'Months',
  years: 'Years',
  decades: 'Decades',
  centuries: 'Centuries',
  millennia: 'Millennia',
  eras: 'Eras',
  forever: 'Forever',

  //common
  sensor_index: 'Sensor index',
  slave_device_number: 'Slave device number',
  select: 'Select',
  create: 'Create',
  update: 'Update',
  relay_index: 'Relay index',
  devices: 'Devices',
  device_name: 'Device Name',
  device_number: 'Device Number',

  //command status
  pending: 'Pending',
  sent: 'Sent',
  cancelled: 'Cancelled',
  status_ok: 'Ok',
  status_nok: 'Not Ok',
  timeout: 'Timeout',
  unknown: 'Unknown',

  // status
  on: 'ON',
  off: 'OFF',
  auto: 'AUTO',

  //Text
  text_add: 'Add',
  text_edit: 'Edit',
  no_data_for_selected_period: 'There is no data for the specified period',
  choose_location: 'Choose a location',
  more_information: 'More Information',
  track_device: 'Track Device',
  not_found: 'Not found',
  powered_by: 'Powered by ',

  // Solution types
  solution_none: 'None',
  solution_agri: 'Smart Agriculture',
  solution_air_quality: 'Air quality monitoring',
  solution_street_lights: 'Street light monitoring',
  solution_pump_station: 'Pumping Station monitoring',
  solution_smart_waste: 'Smart Waste',
  solution_level: 'Level monitoring',
  solution_gas: 'Gas monitoring',
  solution_pressure: 'Pressure monitoring',
  solution_smart_water: 'Smart Water',
  solution_energy: 'Energy monitoring',
  solution_environment_monitoring: 'Environment monitoring',

  //Control buttons
  add_button: 'Add',
  edit_button: 'Edit',
  save_button: 'Save',
  cancel_button: 'Cancel',
  clear_button: 'Clear',
  language_button: 'Language',
  logout_button: 'Logout',
  change_info_for_field: 'Change field information',
  on_button: 'On',
  off_button: 'Off',
  auto_button: 'Auto',
  toggle_button: 'Toggle',
  door_open_sensor_text: 'Open',
  door_closed_sensor_text: 'Closed',
  no_auto_refresh: 'No Auto Refresh',
  refresh_now: 'Refresh Now',

  //Drawer form fields
  drawer_field_information_text: 'Field Information',
  drawer_devices_config: 'Devices configuration',
  drawer_layer_name: 'Layer Name',
  drawer_status: 'Status',
  drawer_region_name: 'Region Name',
  drawer_description: 'Description',
  drawer_layer_size: 'Layer Size',
  drawer_previous_culture: 'Previous Culture',
  drawer_device: 'Device',
  drawer_sensor: 'Sensor',

  //Menu
  menu_home: 'Нome',
  menu_calendar: 'Calendar',
  menu_journal: 'Journal',
  menu_alarms: 'Alarms',
  menu_old_home: 'Home (Old)',
  menu_streetlight: 'Streetlight',
  menu_trashbags: 'Waste bags',
  menu_collections: 'Collections',
  menu_truck_collections: 'Truck Collections',
  menu_truck_collections_by_container: 'Truck Collections by Container',
  menu_container_collections: 'Container Collections',
  menu_reports: 'Reports',

  //Map banner text
  map_banner_select: 'Select a field',
  map_banner_create: 'Create a field',
  map_cluster_devices_header: 'Devices ({{deviceCount}})',

  //Field information widget
  field_info_view: 'View',
  field_info_alarms: 'Alarms',
  field_info_header: 'Field information',
  field_info_status: 'STATUS',
  field_info_region: 'REGION',
  field_info_description: 'Description',
  field_info_area: 'AREA',
  field_info_previous_culture: 'PREVIOUS CULTURE',
  field_info_linked_devices: 'Linked Devices',
  field_info_distance_traveled: 'Distance Traveled',

  //Forecast widget
  forecast_today: 'Today',
  forecast_three_days: '3 days',
  forecast_five_days: '5 days',
  forecast_seven_days: '7 days',
  forecast_min_temp: 'MIN TEMP',
  forecast_max_temp: 'MAX TEMP',
  forecast_cloud_cover: 'CLOUD COVER',
  forecast_rain: 'RAIN',
  forecast_wind: 'WIND',
  forecast_wind_direction: 'WIND DIR',
  forecast_humidity: 'HUMIDITY',

  //Rain Widget
  rain_widget_header: 'Rain',

  //Humidity Widget
  humidity_widget_text: 'Humidity',

  //Soil Moisture Widget
  soil_moisture_widget_text: 'Soil moisture',

  //Control Widget
  control_widget_header: 'Control',
  relay_control_get_relay_statuses: 'Get Relay Statuses',
  poll_linked_devices: 'Poll Linked Devices',

  //Sensor information widget
  sensor_reference_values_label: 'Reference values',
  sensor_board_label: 'SWITCHBOARD',
  sensor_all_info_header: 'Sensors',
  sensor_info_header: 'Sensor information',
  sensor_info_name: 'Name',
  sensor_info_device: 'Device',
  sensor_info_type: 'Type',
  sensor_info_status: 'Status',
  sensor_info_max: 'Max',
  sensor_info_min: 'Min',
  sensor_info_avg: 'Avg',
  sensor_info_current: 'Current',
  sensor_info_counters: 'Counters',
  sensor_info_start_button: 'START',
  sensor_info_stop_button: 'STOP',
  sensor_last_refresh: 'Refreshed: {{time}}',
  sensor_info_board: 'BOARD',
  sensor_info_manufacturer: 'Manufacturer',
  sensor_info_model: 'Model',
  sensor_info_serial_number: 'Serial number',
  sensor_info_diameter: 'Diameter',

  //Street lights information widget
  power_usage: 'ELECTRICITY CONSUMPTION',
  lighting: 'LIGHTING',
  lights_on: 'On',
  lights_off: 'Off',
  door_open: 'Open',
  door_closed: 'Closed',

  //Pump station information
  pump1: 'Pump 1',
  pump2: 'Pump 2',

  //Device Information
  device_information_name: 'Name',
  device_information_number: 'Number',
  device_information_model: 'Model',
  device_information_latitude: 'Latitude',
  device_information_longitude: 'Longitude',

  //Widget detailed button
  widget_detailed_button: 'Detailed',

  //Back To Map Button
  back_to_map_btn: 'Back to map',

  //Wind widget
  wind_widget_header: 'Wind',

  //Dashboard
  boiler_condition_information: 'Information on boiler operating status',
  street_light_information: 'Street Light Information',
  pump_station_information: 'Pump Station Information',
  default_information_panel: 'Device Information',
  dashboard_header: 'Dashboard for field:',
  dashboard_chart_value: 'value',
  select_sensor_message: 'Select a sensor',

  //OnOffAutoLoader
  await_command_execution: 'Please wait for command execution',
  command_successful: 'Command executed successfully',
  command_unsuccessful: 'Error executing command',
  command_error: 'Command not executed',
  loading: 'Loading',

  //Alarms
  alarms_page_header: 'Alarms',
  alarms_page_device_header: 'Alarms for device {{deviceNumber}}',

  alarms_table_date_header: 'Date',
  alarms_table_device_number_header: 'Device Number',
  alarms_table_type_header: 'Type',
  alarms_table_description_header: 'Description',
  alarms_table_sensor_name: 'Sensor name',

  alarms_none_message: 'No alarms for the selected period of time',
  alarms_control_panel_select_date_message: 'Select a date',
  alarms_control_panel_from_date: 'From Date',
  alarms_control_panel_to_date: 'To Date',
  alarms_control_panel_alarm_type: 'Alarm Type',
  alarms_control_panel_alarm_status: 'Alarm Status',
  alarms_control_panel_by_device_number: 'Search by device number',
  alarms_control_panel_header: 'Alarms Filters',

  // Value ranges
  value_ranges_light_rain: 'Light rain',
  value_ranges_moderate_rain: 'Moderate rain',
  value_ranges_heavy_rain: 'Heavy rain',
  value_ranges_violent_rain: 'Violent rain',
  value_ranges_calm_wind: 'Calm wind',
  value_ranges_light_air: 'Light air',
  value_ranges_light_breeze: 'Light breeze',
  value_ranges_gentle_breeze: 'Gentle breeze',
  value_ranges_moderate_breeze: 'Moderate breeze',
  value_ranges_fresh_breeze: 'Fresh breeze',
  value_ranges_strong_breeze: 'Strong breeze',
  value_ranges_high_wind: 'High wind',
  value_ranges_gale: 'Gale',
  value_ranges_severe_gale: 'Severe gale',
  value_ranges_storm: 'Storm',
  value_ranges_violent_storm: 'Violent storm',
  value_ranges_hurricane: 'Hurricane',
  value_ranges_north_1: 'North',
  value_ranges_north_notheast: 'North-Northeast',
  value_ranges_notheast: 'Northeast',
  value_ranges_east_notheast: 'East-Northeast',
  value_ranges_east: 'East',
  value_ranges_east_southeast: 'East-Southeast',
  value_ranges_southeast: 'Southeast',
  value_ranges_south_south_east: 'South-Southeast',
  value_ranges_south: 'South',
  value_ranges_south_southwest: 'South-Southwest',
  value_ranges_southwest: 'Southwest',
  value_ranges_west_southwest: 'West-Southwest',
  value_ranges_west: 'West',
  value_ranges_west_northwest: 'West-Northwest',
  value_ranges_northwest: 'Northwest',
  value_ranges_north_northwest: 'North-Northwest',
  value_ranges_north_2: 'North',
  value_ranges_dry: 'Dry',
  value_ranges_normal: 'Normal',
  value_ranges_wet: 'Wet',
  value_ranges_frost_point: 'Frost point',
  value_ranges_frost_point_danger: 'Frost point danger',
  value_ranges_dew_point: 'Dew point',

  // Data Table Widget
  data_table_widget_header: 'Data',
  data_table_measurements: 'Measurements',
  data_table_alarms: 'Alarms',
  data_table_widget_from_date: 'From Date',
  data_table_widget_to_date: 'To Date',
  data_table_date: 'Date',
  data_table_value: 'Value',
  data_table_range: 'Range',
  flow: 'Flow',
  raw_readings: 'Raw Readings',
  y_axis_include_zero: 'Include 0 on Y-axis',
  chart_options: 'Chart options',

  //sensors types
  rain_sensor: 'Rain Sensor',
  level_sensor: 'Level Sensor',
  wind_speed_sensor: 'Wind Speed Sensor',
  wind_direction_sensor: 'Wind Direction Sensor',
  water_meter: 'Water Meter Sensor',
  pressure_sensor: 'Pressure Sensor',
  humidity_sensor: 'Humidity Sensor',
  temperature_sensor: 'Temperature Sensor',
  gas_flow_meter: 'Gas Flow Meter',
  heat_meter: 'Heat Meter',
  barometric_pressure_sensor: 'Barometric Pressure Sensor',
  soil_moisture_sensor: 'Soil Moisture Sensor',
  on_off_sensor: 'Relay Switch',
  generic_analog_sensor: '--',
  power_meter: 'Power Meter',
  soil_temperature_sensor: 'Soil Temperature',
  dew_point_sensor: 'Dew Point',
  particulate_matter_sensor: 'Particulate Matter',
  geiger_mueller_counter: 'Radiation',
  soil_potential_sensor: 'Soil Potential',
  weight_sensor: 'Weight',

  sensor: {
    rain: {
      name: 'Rain sensor',
      valueRanges: {
        no_rain: {
          abbrv: 'Без дъжд ',
          description: 'When the precipitation rate is < 0.1 мм per hour',
        },
        light_rain: {
          abbrv: 'Light Rain ',
          description: 'When the precipitation rate is between 0.1 and 2.5 mm per hour',
        },
        moderate_rain: {
          abbrv: 'Moderate Rain ',
          description: 'When the precipitation rate is between 2.5 mm and 7.6 mm per hour',
        },
        heavy_rain: {
          abbrv: 'Heavy Rain ',
          description: 'When the precipitation rate is between 7.6 mm and 50 mm per hour',
        },
        violent_rain: {
          abbrv: 'Violent Rain ',
          description: 'When the precipitation rate is > 50 mm per hour',
        },
      },
    },
    windDirection: {
      name: 'Wind Direction',
      valueRanges: {
        north_1: {
          abbrv: 'N',
          description: 'North (349° - 011°)',
        },
        north_2: {
          abbrv: 'N',
          description: 'North (349° - 011°)',
        },
        north_northeast: {
          abbrv: 'NNE',
          description: 'North-Northeast (012°-033°)',
        },
        northeast: {
          abbrv: 'NE',
          description: 'Northeast (034°-056°)',
        },
        east_northeast: {
          abbrv: 'ENE',
          description: 'East-Northeast (102°-123°)',
        },
        east: {
          abbrv: 'E',
          description: 'East (079°-101°)',
        },
        east_southeast: {
          abbrv: 'ESE',
          description: 'East-Southeast (102°-123°)',
        },
        southeast: {
          abbrv: 'SE',
          description: 'Southeast (124°-146°)',
        },
        south_southeast: {
          abbrv: 'SSE',
          description: 'South-Southeast (147°-168°)',
        },
        south_southwest: {
          abbrv: 'SSW',
          description: 'South-Southwest (192°-213°)',
        },
        south: {
          abbrv: 'S',
          description: 'South (169°-191°)',
        },
        southwest: {
          abbrv: 'SW',
          description: 'Southwest (214°-236°)',
        },
        west_southwest: {
          abbrv: 'WSW',
          description: 'West-Southwest (237°-258°)',
        },
        west: {
          abbrv: 'W',
          description: 'West (259°-281°)',
        },
        west_northwest: {
          abbrv: 'WNW',
          description: 'West-Northwest (282°-303°)',
        },
        northwest: {
          abbrv: 'NW',
          description: 'Northwest (304°-326°)',
        },
        north_northwest: {
          abbrv: 'NNW',
          description: 'North-Northwest (327°-348°)',
        },
      },
    },
    windSpeed: {
      name: 'Wind speed sensor',
      valueRanges: {
        no_wind: {
          abbrv: 'No wind',
          description: '(0м/с - 0.1м/с)',
        },
        calm_wind: {
          abbrv: 'Calm wind',
          description: '(0.1m/s - 1m/s)',
        },
        light_air: {
          abbrv: 'Light air',
          description: ' (2m/s - 3m/s)',
        },
        light_breeze: {
          abbrv: 'Light breeze',
          description: ' (4m/s - 6m/s)',
        },
        gentle_breeze: {
          abbrv: 'Gentle breeze',
          description: ' (7m/s - 10m/s)',
        },
        moderate_breeze: {
          abbrv: 'Moderate breeze',
          description: ' (11m/s - 16m/s)',
        },
        fresh_breeze: {
          abbrv: 'Fresh breeze',
          description: '(17m/s - 21m/s)',
        },
        strong_breeze: {
          abbrv: 'Strong breeze',
          description: ' (22m/s - 27m/s)',
        },
        high_wind: {
          abbrv: 'High wind',
          description: ' (28m/s - 33m/s)',
        },
        gale: {
          abbrv: 'Gale',
          description: ' (34m/s - 40m/s)',
        },
        severe_gale: {
          abbrv: 'Strong/severe gale',
          description: ' (41m/s - 47m/s)',
        },
        storm: {
          abbrv: 'Storm',
          description: ' (48m/s - 55m/s)',
        },
        violent_storm: {
          abbrv: 'Violent storm',
          description: ' (56m/s - 63m/s)',
        },
        hurricane: {
          abbrv: 'Hurricane',
          description: ' (64m/s - 77m/s)',
        },
      },
    },
    soil_temperature: {
      valueRanges: {
        idealMin: {
          abbrv: 'Slow growth ',
          description: 'Slow growth - temperature is < 18.3°C',
        },
        idealMax: {
          abbrv: 'Ideal conditions',
          description: 'Ideal max (between 18.4°C and 30°C)',
        },
        warm: {
          abbrv: 'Warm',
          description: 'Slower growth (between 30.1°C and 32.2°C)',
        },
        hot: {
          abbrv: 'Hot',
          description: 'Not efficient growth (between 32.3°C and 45°C)',
        },
        dangerous: {
          abbrv: 'Dangerous',
          description: 'Bacteria dying, losing moisture( > 45.1°C)',
        },
      },
    },
    soilmoisture: {
      valueRanges: {
        dry: {
          abbrv: 'Dry',
          description: 'Dangerously Low Soil Moisture( < 80%)',
        },
        normal: {
          abbrv: 'Irrigate',
          description: 'Irrigation to be applied (between 80% and 90%)',
        },
        wet: {
          abbrv: 'Wet',
          description: 'No irrigation needed( between 90% and 100%)',
        },
      },
    },
    dew_point_sensor: {
      valueRanges: {
        frost_point: {
          abbrv: 'Frost',
          description: 'The dew point is below 1 C.',
        },
        frost_point_danger: {
          abbrv: 'Danger of frost',
          description: 'The dew point is below 5 C.',
        },
        dew_point: {
          abbrv: 'Dew point',
          description: 'The dew point is above 5 C.',
        },
      },
    },
    gammaRadiation: {
      valueRanges: {
        normal: {
          abbrv: 'Normal',
        },
        abnormal: {
          abbrv: 'High',
        },
        dangerous: {
          abbrv: 'Dangerously high',
        },
      },
    },
    moisture: {
      valueRanges: {
        dry: {
          abbrv: 'Dry',
        },
        normal: {
          abbrv: 'Normal',
        },
        wet: {
          abbrv: 'Wet',
        },
      },
    },
    temperature: {
      valueRanges: {
        cool: {
          abbrv: 'Cool',
        },
        ideal: {
          abbrv: 'Ideal',
        },
        warm: {
          abbrv: 'Warm',
        },
        hot: {
          abbrv: 'Hot',
        },
        dangerous: {
          abbrv: 'Dangerously hot',
        },
      },
    },
    airMicroGrams: {
      valueRanges: {
        good: {
          abbrv: 'Low',
        },
        moderate: {
          abbrv: 'Moderate',
        },
        minimal: {
          abbrv: 'Minimal',
        },
        sensitive: {
          abbrv: 'Sensitive',
        },
        discomfort: {
          abbrv: 'Discomfort',
        },
        unhealthy: {
          abbrv: 'Unhealthy',
        },
        veryUnhealthy: {
          abbrv: 'Very unhealthy',
        },
        hazardous: {
          abbrv: 'Hazardous',
        },
        respiratoryIllness: {
          abbrv: 'Dangerous (respiratory Illness)',
        },
        healthImpact: {
          abbrv: 'Dangerous to health',
        },
      },
    },
    barometricPressure: {
      valueRanges: {
        low: {
          abbrv: 'Low',
          description: 'Barometric Pressure is less than 850.',
        },
        normal: {
          abbrv: 'Normal',
          description: 'Barometric Pressure is greater than 850 but less than 1500',
        },
        high: {
          abbrv: 'High',
          description: 'Barometric Pressure is greater than 1500 but less than 3000',
        },
      },
    },
    load_cells: {
      valueRanges: {
        low: {
          abbrv: 'Normal',
          description: 'Load is under 999 kN.',
        },
        normal: {
          abbrv: 'Warning',
          description: 'Load is between 1000 and 1100 kN',
        },
        high: {
          abbrv: 'Alarm',
          description: 'Load is above 1100 kN',
        },
      },
    },
  },

  //GEOMAN MAP LIBRARY CUSTOM TRANSLATE
  // --tooltips--
  placeMarker: 'Click to place marker',
  firstVertex: 'Click to place first vertex',
  continueLine: 'Click to continue drawing',
  finishLine: 'Click any existing marker to finish',
  finishPoly: 'Click first marker to finish',
  finishRect: 'Click to finish',
  startCircle: 'Click to place circle center',
  finishCircle: 'Click to finish circle',
  placeCircleMarker: 'Click to place circle marker',
  placeText: 'Click to place text',

  // -- actions --
  finish: 'Finish',
  cancel: 'Cancel',
  removeLastVertex: 'Remove Last Vertex',

  // -- button titles --
  drawMarkerButton: 'Draw Marker',
  drawPolyButton: 'Draw Polygons',
  drawLineButton: 'Draw Polyline',
  drawCircleButton: 'Draw Circle',
  drawRectButton: 'Draw Rectangle',
  editButton: 'Edit Layers',
  dragButton: 'Drag Layers',
  cutButton: 'Cut Layers',
  deleteButton: 'Remove Layers',
  drawCircleMarkerButton: 'Draw Circle Marker',
  snappingButton: 'Snap dragged marker to other layers and vertices',
  pinningButton: 'Pin shared vertices together',
  rotateButton: 'Rotate Layers',
  drawTextButton: 'Draw Text',

  //CONFIRMATION DIALOG WINDOW
  confirmMessage: 'Are you sure you want to delete this (polygon or area)?',
  confirmAgreeButton: 'Agree',
  confirmDisagreeButton: 'Disagree',

  //Journal
  journal_page_header: 'Journal',

  //Calendar"
  calendar_page_header: 'Calendar',

  //Period-Selector options
  period_label: 'Period',
  route_date_selector: 'Route Date',

  period_date_range_option: 'Date Range',
  period_custom_option: 'Custom',
  period_today_option: 'Today',
  period_week_option: 'Week',
  period_month_option: 'Month',
  period_last_h_option: 'Last hour',
  period_last_2_h_option: 'Last 2 hours',
  period_last_4_h_option: 'Last 4 hours',
  period_last_24_h_option: 'Last 24 hours',
  period_last_48_h_option: 'Last 48 hours',

  //YAMBOL HEADER
  municipality_yambol: 'Yambol Municipality',

  //Devices List
  search_placeholder: 'Search device name',

  //Error-handling
  toast_server_error_message: 'An error occured with one of your requests to the server',
  toast_alarms_error_message: 'Failed to retrieve alarms',
  toast_map_error_message: 'Failed to retrieve map',
  toast_dashboard_error_message: 'Failed to retrieve dashboard',
  toast_devices_error_message: 'Failed to retrieve devices',
  toast_device_config_error_message:
    'Failed to retrieve device configuration for: {{deviceNumber}}',
  toast_device_current_values_error_message:
    'Failed to retrieve current values for: {{deviceNumber}}',
  toast_devices_location_error_message: 'Failed to retrieve devices location',
  toast_map_setting_per_name_error_message:
    'Failed to retrieve the map settings of your current map',
  toast_map_settings_error_message: 'Failed to retrieve all map settings',
  toast_get_user_error_message: 'Failed to retrieve your user',
  toast_set_user_language_error_message: 'Failed to set language',

  //CurrentValuesBox
  current_values_box_info_description: 'No information',
  current_values_box_reference_values: 'Reference values',
  device_info_panel_loading_values: 'Loading current values',
  device_info_panel_no_values: 'No current values available',
  device_info_panel_values_error: 'Could not load current values',

  // Buttons and dropdowns
  alarms_export_header: 'Alarms',
  alarms_export_header_with_device: `Alarms: {{device_number}}`,
  alarms_export_search: 'Search',
  alarms_export_download: 'Download',
  alarms_export_format: 'Format',

  // Table columns
  alarms_export_table_date: 'Date',
  alarms_export_table_device_number: 'Device number',
  alarms_export_table_device_name: 'Device name',
  alarms_export_table_severity: 'Severity',
  alarm_severity_tooltip: 'Severity: {{value}} of 10',
  alarm_severity_none_tooltip: 'No severity reported for this alarm',
  alarms_export_table_sensor_index: 'Sensor index',
  alarms_export_table_sensor_name: 'Sensor name',
  alarms_export_table_alarm_type: 'Type',
  alarm_type_on_off_alarm: 'On/off alarm',
  alarm_type_no_zero_consumption: 'No zero consumption',
  alarm_type_all_zero_consumption: 'All zero consumption',
  alarm_type_low_flow: 'Low flow',
  alarm_type_high_flow: 'High flow',
  alarm_type_high_consumption: 'High consumption',
  alarm_type_missed_transmission: 'Missed transmission',
  alarm_type_device_removed: 'Device removed',
  alarm_type_low_level: 'Low level',
  alarm_type_high_level: 'High level',
  alarm_type_tamper: 'Tamper',
  alarm_type_oversized: 'Oversized',
  alarm_type_undersized: 'Undersized',
  alarm_type_low_battery: 'Low battery',
  alarm_type_blockage: 'Blockage',
  alarm_type_burst: 'Burst',
  alarm_type_reverse_flow: 'Reverse flow',
  alarm_type_range_event: 'Range event',
  alarm_type_very_low_level: 'Very low level',
  alarm_type_very_high_level: 'Very high level',
  alarm_type_leakage: 'Leakage',
  alarm_type_low_temperature: 'Low temperature',
  alarm_type_no_consumption: 'No consumption',
  alarm_type_negative_flow: 'Negative flow',
  alarm_type_empty_spool: 'Empty spool',
  alarm_type_combination_of_alarms: 'Combination of alarms',
  alarm_type_standstill: 'Standstill',
  alarm_type_reset_error: 'Reset error',
  alarm_type_rf_error: 'RF error',
  alarm_type_cs_error: 'CS error',
  alarm_type_measuring_error: 'Measuring error',
  alarm_type_reset_event: 'Reset event',
  alarm_type_magnetic_field: 'Magnetic field',
  alarm_type_sensor_fraud: 'Sensor fraud',
  alarms_export_table_alarm_status: 'Status',
  alarms_export_table_description: 'Description',
  alarms_export_chip_status_active: 'Active',
  alarms_export_chip_status_inactive: 'Inactive',
  alarms_export_switch_title_label: 'Аuto-refresh',
  alarms_export_error_alert_message: 'An error occurred while generating the data.',
  alarms_export_error_too_big_query:
    'Retrieving history from Super Admin for all devices is too big of a request. Please select a company.',

  /*
   * |=================|
   * | Task Scheduler  |
   * |=================|
   */

  task_scheduler_link_label: 'Scheduler',
  task_scheduler_title: 'Task Scheduler',
  task_scheduler_remove: 'Remove',
  task_scheduler_remove_confirmation: 'Are you sure you want to delete the task?',
  task_scheduler_confirm: 'Confirm',
  task_scheduler_cancel: 'Cancel',
  task_scheduler_remove_active: 'Active task cannot be removed',
  task_scheduler_action_not_reversible: 'This action is not reversible.',
  task_scheduler_edit: 'Edit',

  // Form
  task_scheduler_form_name: 'Task name',
  task_scheduler_form_from_date: 'From date',
  task_scheduler_form_to_date: 'To date',
  task_scheduler_form_repeat: 'Repeat',
  task_scheduler_form_period: 'Period',
  task_scheduler_form_temporal: 'Temporal',
  task_scheduler_form_execution_hour: 'Еxecution hour',
  task_scheduler_form_execution_minute: 'Еxecution minute',

  // Toast messages
  task_scheduler_form_create_message: 'Event Added Successfully',
  task_scheduler_form_update_message: 'Event Updated Successfully',
  task_scheduler_form_create_error_message: 'An error occurred while creating the event',
  task_scheduler_form_update_error_message: 'An error occurred while updating the task',
  task_scheduler_form_delete_message: 'Event Removed Successfully',

  // Task execution
  task_execution_error_loading_message: 'Error loading scheduled events',

  // Tasks list
  scheduled_tasks_list_event_name: 'Event name',
  scheduled_tasks_list_start_date: 'Start date',
  scheduled_tasks_list_end_date: 'End date',
  scheduled_tasks_list_execution_time: 'Execution time',
  scheduled_tasks_list_last_execution: 'Last execution',
  scheduled_tasks_list_is_active: 'Is active',
  scheduled_tasks_event_logs_btn_text: 'Event logs',
  scheduled_tasks_view_btn_text: 'View',

  // History table
  scheduled_event_history_title: 'Task history',
  scheduled_tasks_history_date_of_execution_header: 'Date of execution',
  scheduled_tasks_history_status_header: 'Execution status',
  scheduled_tasks_history_overview_btn_text: 'Overview',
  scheduled_tasks_history_task_status_done: 'Done',
  scheduled_tasks_history_task_status_pending: 'Pending',
  scheduled_tasks_history_task_status_failed: 'Failed',
  scheduled_tasks_history_task_status_done_with_errors: 'Done with errors',

  // Task Overview
  task_scheduler_command_task_overview: 'Task Overview',
  task_overview_scheduled_event_name: 'Scheduled Event Name',
  task_overview_desired_state: 'Desired State',
  task_overview_command_state: 'Command State',

  //Event Form
  scheduled_task_event_form_required_state: 'Required state',
  scheduled_task_event_form_required_states: 'Required states',
  scheduled_task_event_form_scheduled_event: 'Scheduled event',
  scheduled_task_event_form_new_scheduled_event: 'New scheduled event',
  scheduled_task_event_form_edit_scheduled_event: 'Edit scheduled event',
  scheduled_task_event_form_event_type: 'Event type',
  scheduled_task_event_form_start_date: 'Start date',
  scheduled_task_event_form_end_date: 'End date',
  scheduled_task_event_form_last_execution: 'Last execution',
  scheduled_task_event_form_execution_time: 'Execution time',
  scheduled_task_event_form_relay_state: 'Relay state',
  scheduled_task_event_form_select: 'Select',
  scheduled_task_event_form_hour: 'Device Execution Hour',
  scheduled_task_event_form_minute: 'Device Execution Minute',
  scheduled_task_event_form_modbus_command_type: 'Command Type',
  scheduled_task_event_form_modbus_command_type_read_coil_1: 'Get Relay State',
  scheduled_task_event_form_modbus_command_type_read_register_3: 'Get Reading',
  scheduled_task_event_form_modbus_command_type_write_coil_5: 'Send Command',

  // Scheduled task event types
  command_type_single_relay_switch: 'Single Relay Switch',
  command_type_relay_switch: 'Relay Switch',
  command_type_auto_relay_switch: 'Auto Relay Switch',
  command_type_send_date_over_mqtt: 'Send Date Over MQTT',
  command_type_modbus: 'Modbus',
  command_type_tasmota_power: 'Tasmota Power',
  command_type_scheduled_relay_command: 'Scheduled Relay',
  command_type_scheduled_relay_command_4: 'Scheduled Relay Commands (4)',
  command: 'Command',

  // Error handling
  scheduled_tasks_could_not_find_event_with_id: `Could not find event with id: {{event_id}}`,
  scheduled_tasks_could_not_get_event_logs_for_event: 'Failed to retrieve logs for the event',
  scheduled_tasks_could_not_update_event_with_id: 'Could not update event with id: {{event_id}}',
  logo_error_message: 'Could not load company logo',

  // resolvers
  scheduled_tasks_event_name_min_length: 'Event name must be at least 3 characters long',
  scheduled_tasks_event_name_max_length: 'Event name must be less than 50 characters long',
  scheduled_tasks_from_date_invalid: 'From date must be after today',
  scheduled_tasks_to_date_invalid: 'To date must be after from date',
  scheduled_tasks_execution_hour_range: 'Execution hour must be between 0 and 23',
  scheduled_tasks_execution_minute_range: 'Execution minute must be between 0 and 59',
  scheduled_tasks_period_required: 'Period must be a positive integer',
  scheduled_tasks_temporal_required: 'Temporal value is required',
  scheduled_tasks_event_device_numbers_length:
    'Each device number must be exactly 8 characters long',
  scheduled_tasks_event_sensor_index_range: 'Sensor index must be a positive integer or 0',
  scheduled_tasks_event_relay_states_required:
    'Relay states must be specified for RELAY_SWITCH type',
  scheduled_tasks_event_required_state_auto_relay:
    'Required state must be specified for AUTO_RELAY_SWITCH type',
  scheduled_tasks_event_required_state_tasmota_power:
    'Required state must be specified for TASMOTA_POWER type',
  scheduled_tasks_event_slave_device_number_length:
    'Slave device number must be exactly 8 characters long',
  scheduled_tasks_event_type_invalid: 'Invalid event type selected',
  scheduled_tasks_device_number_is_required: 'Select device(s) to create event',

  /*
   * |=====================|
   * | License Error Page  |
   * |=====================|
   */
  license_error_page_access_restricted: 'Access Restricted',
  license_warning_access_hold: 'Account Access on Hold',
  license_warning_access_hold_description:
    'Your access to the platform has been temporarily suspended due to unresolved payment. We encourage you to reach out to our support or connect with your designated representative to assist you in resolving this matter.',
  license_warning_no_valid_license: 'No valid license',
  license_warning_no_valid_license_description:
    'We could not find valid license associated with this account. Please reach out to your designated representative or contact our support for assistance.',
  license_warning_devices_count_limit_reached: 'Maximum Devices Reached',
  license_warning_devices_count_limit_reached_description:
    'You have reached the maximum devices you can link to the account from the license. If you want to add more, please contact your designated representative or our support for assistance.',
  license_warning_generic_title: 'No License',
  license_warning_generic_description: 'Can not proceed due to license issue.',
  error_forbidden_operation_not_allowed: 'Not Allowed',

  /*
   * |=================|
   * | Trashbags       |
   * |=================|
   */
  trashbags_page_header: 'Waste bags',
  trashbags_status_new: 'New',
  trashbags_status_in_progress: 'In Progress',
  trashbags_status_closed: 'Closed',
  trashbags_fetch_error: 'Error fetching batches',
  trashbags_batch_details_error: 'Error fetching batch details',
  trashbags_batch_number: 'Bag Roll',
  trashbags_batch_id: 'Roll ID',
  trashbags_total_count: 'Total',
  trashbags_new: 'New',
  trashbags_in_progress: 'In Progress',
  trashbags_closed: 'Closed',
  trashbags_id: 'ID',
  trashbags_rfid: 'RFID',
  trashbags_status: 'Status',
  trashbags_account_number: 'Batch Number',
  trashbags_created_date: 'Creation Date',
  trashbags_collection_date: 'Collection Date',
  trashbags_more_info_tooltip: 'Click to see more information',
  trashbags_details_title: 'Bag Details',
  trashbags_type: 'Type',
  trashbags_location: 'Location',
  trashbags_open_in_maps: 'Open in Google Maps',
  trashbags_empty_title: 'No waste bag rolls found',
  trashbags_empty_description: 'There are no waste bag rolls to display yet.',
  trashbags_batch_empty_title: 'No waste bags in this roll',
  trashbags_batch_empty_description: 'This roll does not contain any waste bags yet.',

  /*
   * |=================|
   * | Collections     |
   * |=================|
   */
  collections_page_header: 'Waste Collection Report',
  collections_fetch_error: 'Error fetching collection data',
  collections_from_date: 'From Date',
  collections_to_date: 'To Date',
  collections_account_number: 'Batch Number',
  collections_account_id: 'Account ID',
  collections_count: 'Collection Count',
  collections_volume: 'Collection Volume',
  collections_export_csv: 'Export',
  collections_no_data_to_export: 'No data to export',

  /*
   * |====================|
   * | Truck Collections  |
   * |====================|
   */
  truck_collections_page_header: 'Truck Collections Report',
  truck_collections_fetch_error: 'Error fetching truck collections data',
  truck_collections_from_date: 'From Date',
  truck_collections_to_date: 'To Date',
  truck_collections_truck_name: 'Truck Name',
  truck_collections_count: 'Collections Count',
  truck_collections_volume: 'Collections Volume',
  truck_collections_export_csv: 'Export CSV',
  truck_collections_view_on_map: 'View on Map',
  truck_collections_no_data_to_export: 'No data to export',

  /*
   * |================================|
   * | Truck Collections by Container |
   * |================================|
   */
  truck_collections_by_container_page_header: 'Truck Collections by Container Report',
  truck_collections_by_container_fetch_error: 'Error fetching truck collections by container data',
  truck_collections_by_container_from_date: 'From Date',
  truck_collections_by_container_to_date: 'To Date',
  truck_collections_by_container_truck_number: 'Truck Name',
  truck_collections_by_container_container_number: 'Container Number',
  truck_collections_by_container_container_address: 'Container Address',
  truck_collections_by_container_location: 'Location',
  truck_collections_by_container_status: 'Status',
  truck_collections_by_container_date: 'Date',
  truck_collections_by_container_status_correct: 'Correct Location',
  truck_collections_by_container_status_incorrect: 'Incorrect Location',
  truck_collections_by_container_open_in_maps: 'Open in Google Maps',
  truck_collections_by_container_export_csv: 'Export CSV',
  truck_collections_by_container_view_on_map: 'View on Map',
  truck_collections_by_container_no_data_to_export: 'No data to export',

  /*
   * |=======================|
   * | Container Collections |
   * |=======================|
   */
  container_collections_page_header: 'Container Collections Report',
  container_collections_fetch_error: 'Error fetching container collections data',
  container_collections_from_date: 'From Date',
  container_collections_to_date: 'To Date',
  container_collections_container_number: 'Container Number',
  container_collections_container_address: 'Container Address',
  container_collections_account_id: 'Account ID',
  container_collections_account_number: 'Account Number',
  container_collections_count: 'Collections Count',
  container_collections_volume: 'Collections Volume',
  container_collections_export_csv: 'Export CSV',
  container_collections_no_data_to_export: 'No data to export',

  // Common
  close_btn: 'Close',

  // TanstackTable UI
  table_search_placeholder: 'Search…',
  table_columns: 'Columns',
  table_toggle_all: 'Toggle all',
  table_filter: 'Filter',
  table_clear_filter: 'Clear filter',
  table_pin_left: 'Pin left',
  table_pin_right: 'Pin right',
  table_unpin: 'Unpin',
  table_group_by_column: 'Group by this column',
  table_ungroup: 'Ungroup',
  table_filter_all: 'All',
  table_no_values: 'No values',
  table_min: 'Min',
  table_max: 'Max',
  table_equals: 'Equals',
  table_from: 'From',
  table_to: 'To',
  table_yes: 'Yes',
  table_no: 'No',
  table_filter_placeholder: 'Filter…',
  table_density_compact: 'Compact',
  table_density_standard: 'Standard',
  table_density_comfortable: 'Comfortable',
  table_auto_page_size: 'Auto ({rows})',
};

export default en;
